import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: true,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_SETTLEMENTS_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_SETTLEMENTS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_SETTLEMENTS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      };
    }

    default: {
      return state;
    }
  }
};
